'use client';

import { heliosSizes } from '~/constants/common/resizeBreakpoints';
import useDataDogRUM from '~/hooks/common/telemetry/useDataDogRUM';
import { useTrackClickEvents } from '~/hooks/common/telemetry/useTrackClickEvents';
import useResizeListener from '~/hooks/common/ui/useResizeListener';
import useSuppressHeroFromPromo from '~/hooks/new-cars/useSuppressHeroFromPromo';

type Props = {
  arrivedFromPromo: boolean;
};

export default function MakesPageData({ arrivedFromPromo }: Props) {
  useDataDogRUM();
  useResizeListener(heliosSizes);
  useSuppressHeroFromPromo(arrivedFromPromo);
  useTrackClickEvents();

  return null;
}
